import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { MdRemoveRedEye } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { BeatLoader, BounceLoader } from "react-spinners";
import { useReactToPrint } from "react-to-print";
import CustomerType from "../../../components/modals/customers/create/CustomerType";
import PageTitle from "../../../components/partials/PageTitle";
import {
  getClaims,
  resetSingleClaims,
} from "../../../redux/slice/claim/claimSlice";
import {
  resetSingleClaims as resetSavingsClaim,
} from "../../../redux/slice/claim/savingClaimSlice";
import { getCustomerClaims } from "../../../redux/slice/customer/customerSlice";
import { resetPolicyStatus } from "../../../redux/slice/policy/policySlice";

// sort customers base on whether corperate or individual customers
// const sortCorperateCustomers = (customers) =>
//   customers?.corperate?.data?.filter(
//     (customer) => customer?.customer_type === "Corporate"
//   );

// main component starts here
const CustomerClaims = () => {
  // redux state calls
  const { user } = useSelector((state) => state?.auth?.user);
  const { all_users } = useSelector((state) => state?.user);
  const { customer_claims, } =
    useSelector((state) => state?.customer);
  const {
    offices: { offices },
  } = useSelector((state) => state.office);

  // local states and refs
  const [currentClaims, setCurrentClaims] = useState(null);
  // const [searchBy, setSearchBy] = useState("");
  // const [pageNumber, setPageNumber] = useState(1);
  const CCPdfRef = useRef();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { customer_id } = useParams();
  // print table to pdf
  // const generatePDF = useReactToPrint({
  //   content: () => CCPdfRef.current,
  //   documentTitle: "initiated claims",
  // });
  // breadcrumb
  const breadcrumb = {
    from: {
      title: "customer claims",
      link: `/admin/customer-profile/${location.state}`,
    },
    current: {
      title: "overview",
      link: null,
    },
  };

  // const handleSearchBy = (e) => {
  //   e.preventDefault();
  //   if (searchBy) {
  //     dispatch();
  //     // searchClaims({ search: searchBy, office_id: user?.office_id })
  //   }
  // };

  // fetch customers on click of pagination links
  // const fetchCorperateCustomersHandler = async (pageNum) => {
  //   setPageNumber(pageNum);
  //   dispatch(getClaims({ pageNumber: pageNum, office_id: user?.office_id }));
  //   // dispatch(resetPolicyStatus());
  // };

  // get all claims on first load
  useEffect(() => {
    dispatch(getCustomerClaims({ pageNumber: 1, customer_id }));
    dispatch(resetPolicyStatus());
    dispatch(resetSingleClaims());
    dispatch(resetSavingsClaim());
  }, [dispatch, user?.office_id]);

  useEffect(() => {
    if (customer_claims) {
      setCurrentClaims(customer_claims);
    }
  }, [customer_claims]);


  if (!customer_claims) {
    return (
      <div className='mt-2'>
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Customer Claims' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row mt- card p-1 mx-0 mb-3'>
        <div className='d-flex justify-content-between align-items-center py-2 mt-2'>
          <div>
            <h4 className='text-primary-1'>General Claims</h4>
          </div>
          {/* <div>
            <button
              className='btn btn-sm btn-primary d-flex align-items-center gap-1'
              onClick={() => navigate(-1)}
            >
              <BsArrowLeft />
              <span>Back</span>
            </button>
          </div> */}
          {/* <div className='d-flex justify-content-between align-items-center gap-3'>
            <form
              onSubmit={handleSearchBy}
              className='d-flex bg-primary-1 align-items-center '
              style={{ height: "30px", width: "217px" }}
              ref={searchCorp}
            >
              <input
                type='search'
                value={searchBy}
                className='border-0'
                placeholder='Search...'
                onChange={(e) => setSearchBy(e.target.value)}
                style={{
                  height: "28px",
                  marginLeft: "1px",
                  outline: "none",
                }}
              />
              <button
                type='submit'
                className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                style={{ height: "28px" }}
              >
                <i className='uil uil-search text-white fs-4'></i>
              </button>
            </form>
            <div className=' d-flex align-items-center border '>
              <span
                className='bg-info me-2 text-white'
                style={{ padding: "3px" }}
              >
                Export to
              </span>

              <span
                href='#'
                id='btnExport'
                className='me-1 cursor-p'
                title='Export to Pdf'
                onClick={generatePDF}
              >
                <img src={pdf} alt='export-pdf' style={{ height: "20px" }} />
              </span>
              {currentClaims ? (
                <CSVLink
                  data={exportXlsxData(currentClaims, "All Policies")}
                  style={{ fontWeight: "bolder", cursor: "pointer" }}
                  filename='Corperate customers'
                >
                  <span
                    href='#'
                    id='btnExport'
                    className='mr-1'
                    title='Export to Excel'
                  >
                    <img
                      src={excel}
                      alt='export-excel'
                      style={{ height: "20px", marginRight: "5px" }}
                    />
                  </span>
                </CSVLink>
              ) : null}
            </div>
          </div> */}
        </div>
        <div className='col-12'>
          <div className='position-relative'>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='table-responsive'>
                  <table
                    className='table table-centered table-striped nowrap w-100 no-footer'
                    ref={CCPdfRef}
                  >
                    <thead>
                      <tr>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "130.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Claims ID
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "225.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Policy No.
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Policy Name
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Total Premium
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Claims Amount
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Status
                        </th>

                        <th
                          className='sorting text-center'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "165.8px" }}
                          aria-label='Status: activate to sort column ascending'
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    {currentClaims?.view_customer_claim?.length ? (
                      <tbody>
                        {currentClaims?.view_customer_claim?.map((item, i) => (
                          <tr key={i}>
                            <td>
                              <span>{item.claimId}</span>
                            </td>
                            <td>{item?.policyNumber}</td>
                            <td className=''>{item?.policyName}</td>
                            <td className=''>{item.totalPremium}</td>
                            <td className=''>{item?.claimAmount}</td>
                            <td>
                              <span className='badge badge-warning-lighten'>
                                {item?.awaiting_status &&
                                item?.decline_status === "0" &&
                                item?.claim_status === "0"
                                  ? "Awaiting " +
                                    item?.awaiting_status +
                                    " approval"
                                  : null}
                              </span>
                              <span className='badge badge-danger-lighten'>
                                {item?.decline_status &&
                                item?.claim_status === "0" &&
                                item?.decline_status !== "0"
                                  ? item?.decline_status
                                  : null}
                              </span>
                              <span className='badge badge-success-lighten'>
                                {item?.claim_status
                                  ? item?.claim_status === "1" && "Approved"
                                  : null}
                              </span>
                            </td>
                            {customer_claims && (
                              <td className='text-center'>
                                <Link
                                  to={`/admin/claims/edit`}
                                  className='text-left'
                                  state={{ id: item?.claimId }}
                                  // onClick={() =>
                                  //   dispatch(getSingleClaim(item?.claim_id))
                                  // }
                                >
                                  <MdRemoveRedEye
                                    className='text-primary'
                                    style={{
                                      fontSize: "20px",
                                      textAlign: "start",
                                    }}
                                  />
                                </Link>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </table>
                </div>
                {currentClaims?.view_customer_claim?.length < 1 ? (
                  <h5 className='alert alert-info'>No result found!</h5>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <CustomerType modal_id='create_customer_step_1' />
      </div>
      <div className='row mt- card p-1 mx-0 '>
        <div className='d-flex justify-content-between align-items-center py-2 mt-2'>
          <div>
            <h4 className='text-primary-1'>Savings Claims</h4>
          </div>
          {/* <div>
            <button
              className='btn btn-sm btn-primary d-flex align-items-center gap-1'
              onClick={() => navigate(-1)}
            >
              <BsArrowLeft />
              <span>Back</span>
            </button>
          </div> */}
          {/* <div className='d-flex justify-content-between align-items-center gap-3'>
            <form
              onSubmit={handleSearchBy}
              className='d-flex bg-primary-1 align-items-center '
              style={{ height: "30px", width: "217px" }}
              ref={searchCorp}
            >
              <input
                type='search'
                value={searchBy}
                className='border-0'
                placeholder='Search...'
                onChange={(e) => setSearchBy(e.target.value)}
                style={{
                  height: "28px",
                  marginLeft: "1px",
                  outline: "none",
                }}
              />
              <button
                type='submit'
                className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                style={{ height: "28px" }}
              >
                <i className='uil uil-search text-white fs-4'></i>
              </button>
            </form>
            <div className=' d-flex align-items-center border '>
              <span
                className='bg-info me-2 text-white'
                style={{ padding: "3px" }}
              >
                Export to
              </span>

              <span
                href='#'
                id='btnExport'
                className='me-1 cursor-p'
                title='Export to Pdf'
                onClick={generatePDF}
              >
                <img src={pdf} alt='export-pdf' style={{ height: "20px" }} />
              </span>
              {currentClaims ? (
                <CSVLink
                  data={exportXlsxData(currentClaims, "All Policies")}
                  style={{ fontWeight: "bolder", cursor: "pointer" }}
                  filename='Corperate customers'
                >
                  <span
                    href='#'
                    id='btnExport'
                    className='mr-1'
                    title='Export to Excel'
                  >
                    <img
                      src={excel}
                      alt='export-excel'
                      style={{ height: "20px", marginRight: "5px" }}
                    />
                  </span>
                </CSVLink>
              ) : null}
            </div>
          </div> */}
        </div>
        <div className='col-12'>
          <div className='position-relative'>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='table-responsive'>
                  <table
                    className='table table-centered table-striped nowrap w-100 no-footer'
                    ref={CCPdfRef}
                  >
                    <thead>
                      <tr>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "130.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Claims ID
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "225.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Policy No.
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Policy Name
                        </th>
                        <th
                          className="sorting"
                          tabIndex="0"
                          rowSpan="1"
                          colSpan="1"
                          style={{ width: "120.8px" }}
                          aria-label="Status: activate to sort column ascending"
                        >
                          Claim Category
                        </th>
                        <th
                          className="sorting"
                          tabIndex="0"
                          rowSpan="1"
                          colSpan="1"
                          style={{ width: "120.8px" }}
                          aria-label="Status: activate to sort column ascending"
                        >
                          Claim Type
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Total Premium
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Claims Amount
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Status
                        </th>

                        <th
                          className='sorting text-center'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "165.8px" }}
                          aria-label='Status: activate to sort column ascending'
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    {currentClaims?.customer_savings_claim?.length ? (
                      <tbody>
                        {currentClaims?.customer_savings_claim?.map((item, i) => (
                          <tr key={i}>
                            <td>
                              <span>{item.claimId}</span>
                            </td>
                            <td>{item?.policyNumber}</td>
                            <td className=''>{item?.policyName}</td>
                            {<td className="table-user">
                              <span className="">
                                {item?.ClaimCategory
                                  ? item?.ClaimCategory === "other_cover" && "Other Cover"
                                  : null}
                              </span>
                              <span className="">
                                {item?.ClaimCategory
                                  ? item?.ClaimCategory === "savings_claim" && "Savings Claim"
                                  : null}
                              </span>
                            </td>}
                            {<td className="table-user">
                              <span className="">
                                {item?.ClaimType
                                  ? item?.ClaimType === "1" && "Maturity"
                                  : null}
                              </span>
                              <span className="">
                                {item?.ClaimType
                                  ? item?.ClaimType === "2" && "Termination"
                                  : null}
                              </span>
                              <span className="">
                                {item?.ClaimType
                                  ? item?.ClaimType === "3" && "Partial Withdrawal"
                                  : null}
                              </span>
                            </td>}
                            <td className=''>{item?.ClaimCategory === "other_cover" ? item.totalPremium : item?.totalContribution}</td>
                            <td className=''>{item?.ClaimCategory === "other_cover" ? item?.claimAmount : item?.AmountPayable}</td>
                            <td>
                              <span className='badge badge-warning-lighten'>
                                {item?.awaiting_status &&
                                item?.decline_status === "0" &&
                                item?.claim_status === "0"
                                  ? "Awaiting " +
                                    item?.awaiting_status +
                                    " approval"
                                  : null}
                              </span>
                              <span className='badge badge-danger-lighten'>
                                {item?.decline_status &&
                                item?.claim_status === "0" &&
                                item?.decline_status !== "0"
                                  ? item?.decline_status
                                  : null}
                              </span>
                              <span className='badge badge-success-lighten'>
                                {item?.claim_status
                                  ? item?.claim_status === "1" && "Approved"
                                  : null}
                              </span>
                            </td>
                            {customer_claims && (
                              <td className='text-center'>
                                <Link
                                  to={`/admin/claims/all-savings-claims/edit`}
                                  className='text-left'
                                  state={{ claim_type:item?.ClaimType, claim_category: item?.ClaimCategory, claim_id: item?.claimId, policy_application_number: item?.policyNumber, customer_id}}
                                  // onClick={() =>
                                  //   dispatch(getSingleClaim(item?.claim_id))
                                  // }
                                >
                                  <MdRemoveRedEye
                                    className='text-primary'
                                    style={{
                                      fontSize: "20px",
                                      textAlign: "start",
                                    }}
                                  />
                                </Link>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </table>
                </div>
                {currentClaims?.customer_savings_claim?.length < 1 ? (
                  <h5 className='alert alert-info'>No result found!</h5>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <CustomerType modal_id='create_customer_step_1' />
      </div>
    </>
  );
};

export default CustomerClaims;
